import customAxios from "../../customAxios";
import {IS_USER_AND_TYPE_EXIST} from "../../routes";

interface IProps {
  phoneNumber: string;
  userType: any;
}
const userAndTypeExist = async ({phoneNumber, userType}: IProps) => {
  const thisURL = `?phoneNumber=${phoneNumber}&userType=${userType}`;

  try {
    return (await customAxios.get(IS_USER_AND_TYPE_EXIST + thisURL)).data;
  } catch (error: any) {
    console.error({IS_USER_AND_TYPE_EXIST: error});
  }
};
export default userAndTypeExist;
